import type { ContentVersion } from '@opallabs/api'
import type { VersionFilter } from './types'

/**
 * A milestone is a version someone chose to label — deliberate curation, not a
 * side effect of feedback landing on it.
 */
export const isMilestone = (version: ContentVersion): boolean =>
  Boolean(version.label)

/**
 * The versions a filter leaves on screen. The rail renders these, the stepping
 * controls walk them, and compare picks from them — all through here, so none of
 * the three can disagree about what the reader can see.
 */
export const filterVersions = (
  versions: ContentVersion[],
  filter: VersionFilter
): ContentVersion[] =>
  filter === 'milestones' ? versions.filter(isMilestone) : versions
